/** Ensures only one HTMLVideoElement plays at a time across the app. */

let activeVideoEl = null;

export function handleExclusiveVideoPlay(event) {
  const el = event?.currentTarget;
  if (!(el instanceof HTMLVideoElement)) return;

  if (activeVideoEl && activeVideoEl !== el) {
    activeVideoEl.pause();
  }
  activeVideoEl = el;
}

export function handleExclusiveVideoPause(event) {
  const el = event?.currentTarget;
  if (!(el instanceof HTMLVideoElement)) return;

  if (activeVideoEl === el) {
    activeVideoEl = null;
  }
}
